import { Visible } from '@box/blueprint-web-assets/icons/Line';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import style from './forms-preview-header.module.scss';

const FormsPreviewHeader = () => {
  return (
    <div data-testid="forms-preview-header" className={style.container}>
      <Visible className={style.previewIcon} height={16} width={16} />
      <FormattedMessage {...messages.formsPreviewHeaderText} />
    </div>
  );
};

export default FormsPreviewHeader;
